import { isDesktopView, l, lc, lm, lreplace } from '@js/utils/toolbox';
import { resultsRender } from './resultsRender';


export const staticContentPrefix = '/static/v' + js_params.version;

export function getTripType (journey) {
	if ([js_params.returntrip, journey?.favouriteMeta?.returntrip].includes(0)) {
		return 'oneway';
	} else if ([js_params.returntrip, journey?.favouriteMeta?.returntrip].includes(2)) {
		return 'openjaw';
	}
	return 'return';
}

export function moreInfoAgencyCount (count) {
	let text = null;

	if (count > 1) {
		text = lreplace('showresult.result.showAdditionalAgencyCount', { agencyCount: count });
	} else {
		text = l('showresult.result.showMoreInfo');
	}

	return text;
}

export function isSavedAsFavorite (flight) {
	if (!window?.favoriteComponent?.itemGetIndexByUid) {
		return '';
	}
	const responseId = js_params?.id || flight.favouriteMeta?.responseId || '';
	const favoriteUid = window.favoriteComponent.itemGenerateUid(responseId, flight.orgIndex, flight.agents[0].urlOptions);

	return window.favoriteComponent.itemGetIndexByUid(favoriteUid) !== -1 ? 'favorited' : '';
}

export function abLegStops (stops) {
	if (parseInt(stops) === 1) {
		return lreplace('showresult.result.transferCountSingle', { transferCount: stops });
	} else if (parseInt(stops) > 1) {
		return lreplace('showresult.result.transferCountMultiple', { transferCount: stops });
	} else {
		return l('showresult.result.directFlight');
	}
}

export function passengersText (flight) {
	let text = '';

	if (flight?.favouriteMeta?.passengers?.adults === 1) {
		text += lreplace('searchBox.adults.singular');
	} else {
		text += lreplace('searchBox.adults.numPlural', { number: flight?.favouriteMeta?.passengers?.adults });
	}

	if (flight?.favouriteMeta?.passengers?.child?.count) {
		if (flight.favouriteMeta.passengers.child.count === 1) {
			text += ' ' + lreplace('searchBox.childrens.singular');
		} else {
			text += ' ' + lreplace('searchBox.childrens.plural', {
				number: flight.favouriteMeta.passengers.child.count
			});
		}
	}

	return text;
}

const TICKET_TYPE_ICON_MAP = {
	0: 'icon-chair',
	1: 'icon-chair-wine',
	2: 'icon-chair-cocktail',
	3: 'icon-chair-coffee',
	4: 'icon-chair-combined'
};
export function ticketTypeIcon (cabin) {
	return TICKET_TYPE_ICON_MAP[cabin] || 'icon-chair';
}

const CABIN_LABEL_MAP = {
	0: l('searchBox.ticketType.economy'),
	1: l('searchBox.ticketType.business'),
	2: l('searchBox.ticketType.firstClass'),
	3: l('searchBox.ticketType.premium'),
	4: l('searchBox.ticketType.combined')
};
export function cabinType (cabin) {
	return CABIN_LABEL_MAP[cabin] || '';
}

export function renderIndex (i) {
	return Number(i) + 1;
}

export function favouriteStatus (flight) {
	const classes = [];
	if (flight?.favouriteMeta?.isOld) {
		classes.push('oldResult');
	}

	if (flight?.favouriteMeta?.isPast) {
		classes.push('pastResult');
	}

	if (flight?.favouriteMeta?.isChanging) {
		classes.push('changingResult');
	}

	return classes.join(' ');
}

export function join (arr, fn) {
	return (arr ?? []).map(fn).join('');
}

export function escapeAttr (s) {
	return String(s).replace(/"/g, '&quot;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
}

const TRACKING_CLASS_MAP = {
	baggage: 'baggageIncluded',
	cabinBaggage: 'cabinBaggageIncluded',
	climateCompensated: 'carbonOffset',
	rebookable: 'flexTicket'
};
export function getPromotedValue (product) {
	return TRACKING_CLASS_MAP[product] || product;
}

window.resultsTemplateHandleMissingLogo = (targetImg) => {
	const missingAirlineLogo = lm('/assets/images/airlines/iata/unknown.png');

	if (targetImg.src !== missingAirlineLogo) {
		targetImg.src = missingAirlineLogo;
	}
};

export function getEmissionText (flight) {
	if (document.body.classList.contains('search-loading')) {
		return;
	}

	const device = isDesktopView() ? 'Desktop' : '';
	const sorted = resultsRender.isEmissionSorting;
	const { climateCompensationPrice, climateCompensationUrl } = flight;
	const price = lc(climateCompensationPrice);
	const url = climateCompensationUrl;

	if (resultsRender.isClimateCompensatedFiltered) {
		return `${l('showresult.result.includeYourCompensation')} ${price}`;
	} else {
		if (sorted && flight.compensated_emission != flight.raw_emission) {
			return lreplace(`showresult.result.climateCompensation${device}`, { price, url });
		}
	}

	return '';
}


export function getFlightEmissionsData (emissions, compensated, net) {
	let isFullyCompensated = false;
	let isEmissionAbnormallyHigh = false;
	let hasAirlineCompensation = false;
	let airlineCompensation = 0;
	let userCompensation = 100;
	let emissionLegend = '';
	let emissionValueWithUnit = '';
	let emissionDefinition = '';
	let isSortedByNet = false;
	let emissionValue = emissions;


	const isFlightFullyBioFueled = (emissions === 0 && compensated === 0);
	if (emissions || isFlightFullyBioFueled) {
		emissions = Math.round(emissions);
		compensated = Math.round(compensated);

		if (resultsRender.isEmissionSorting || resultsRender.isClimateCompensatedFiltered) {
			hasAirlineCompensation = (compensated !== 0) || isFlightFullyBioFueled;
			isFullyCompensated = compensated === emissions;
			isEmissionAbnormallyHigh = checkIfEmissionAbnormallyHigh(emissions);

			airlineCompensation = 0;
			userCompensation = 100;

			if (hasAirlineCompensation) {
				airlineCompensation = (isFlightFullyBioFueled) ? 100 : Math.round((compensated * 100) / emissions);
				userCompensation -= airlineCompensation;
			}

			emissionLegend = getEmissionLegend(userCompensation, airlineCompensation);
			emissionValueWithUnit = getFormattedEmissionWithUnit(emissions);

			if ((compensated !== 0) || isFlightFullyBioFueled || isEmissionAbnormallyHigh) {
				emissionDefinition = getNetEmissionDefinition(emissions, compensated);
				isSortedByNet = true;
				emissionValue = net;
			}
		}
	}

	return {
		isFullyCompensated,
		isEmissionAbnormallyHigh,
		hasAirlineCompensation,
		airlineCompensation,
		userCompensation,
		emissionLegend,
		emissionValueWithUnit,
		emissionDefinition,
		isSortedByNet,
		emissionValue
	};
}

export function getEmissionLegend (userComp, airlineComp) {
	const translation = airlineComp === 100 ? l('global.simplePhrases.compensated') : '';
	let legend = '';

	if (airlineComp > 0) {
		legend = `${airlineComp}% ${translation} ${l('showresult.result.byAirline')} `;

		if (airlineComp != 100) {
			legend += `${l('global.simplePhrases.and')} `;
		}
	}

	if (userComp > 0) {
		legend += `${userComp}% ${l('showresult.result.byUser')}`;
	}

	return legend;
}

export function getFormattedEmissionWithUnit (emissions) {
	if (checkIfEmissionAbnormallyHigh(emissions)) {
		return l('global.simplePhrases.high');
	} else if (emissions / 1000 < 1) {
		return lreplace('global.simplePhrases.kilo', { weight: emissions });
	} else {
		return lreplace('global.simplePhrases.ton', { weight: (emissions / 1000).toFixed(2) });
	}
}

/**
 * @param {Number} emissions
 * @returns {Boolean}
*/
export function checkIfEmissionAbnormallyHigh (emissions) {
	return emissions > 999998;
}

/**
	 * @param {Number} grossEmission
	 * @param {Number} compensatedEmission
	 * @returns {String}
	 */
export function getNetEmissionDefinition (grossEmission, compensatedEmission) {
	if (checkIfEmissionAbnormallyHigh(grossEmission)) {
		return lreplace('showresult.result.abnormalEmissionDef', { grossEmission });
	} else if (grossEmission === 0) {
		return l('showresult.result.zeroEmissionDef');
	} else {
		return lreplace('showresult.result.netEmissionDef', { compensatedEmission, grossEmission });
	}
}


export function insertIf (condition, html) {
	if (!condition) {
		return '';
	}

	const isFunction = typeof html === 'function';

	if (isFunction) {
		return html();
	}

	return html;
}


export function getStopMetadata (seg) {
	if (seg.requiresAirportChange) {
		return {
			styles: 'abResult__stop--change',
			icon: 'icon-person-luggage',
			stopText: lreplace('showresult.result.warningAirportChange', { wait: seg.waitTime }).split(':')[0]
		};
	}

	const dictionary = { arrivalCity: seg.arrivalCity, wait: seg.waitTime };
	const lookup = {
		long: {
			styles: 'abResult__stop--longWait',
			icon: 'icon-circle-time',
			stopText: lreplace('showresult.result.warningLongWaitingTime', dictionary).split(':')[0]
		},
		short: {
			styles: 'abResult__stop--shortWait',
			icon: 'icon-circle-time',
			stopText: lreplace('showresult.result.warningShortWaitingTime', dictionary).split(':')[0]
		}
	};

	return lookup[seg.waitingTimeStatus] || {
		styles: 'abResult__stop--wait',
		icon: 'icon-plane',
		stopText: lreplace('showresult.result.waitingTime', dictionary).split(':')[0]
	};
}

export function aircraftType (aircraft) {
	return !aircraft || aircraft === 'empty'
		? l('showresult.aircraftUnknown.text')
		: aircraft;
}

export function getAircraftType (equipment) {
	const aircraft = resultsRender.response?.equipment?.[equipment] || '';

	if (
		js_params?.missingDetailsReport
		&& resultsRender.response.equipment
		&& !aircraft
		&& equipment && !resultsRender.missingResultDetails.aircraftTypes.includes(equipment)
	) {
		resultsRender.missingResultDetails.aircraftTypes.push(equipment);
		console.warn(`Unknown aircraft type: '${equipment}'`);
		resultsRender.missingResultDetailsTrackers.aircraftTypes.reportError(new Error(`Unknown aircraft type: '${equipment}'`));
	}

	return aircraft;
}


export function tripGetToAndFromCity (trip) {
	const fromCity = trip.segment[0].departureCity;
	const toCity = trip.segment[trip.segment.length - 1].arrivalCity;
	return { fromCity, toCity };
}
